import type { UseModule } from '~/types'
import { install as girassol } from '@solfacil/girassol'
import '@solfacil/girassol/dist/style.css'

export const install: UseModule = ({ instance }) => {
  instance.use(girassol)
}
